/* Arrows for the header rails.

   A rail only overflows on some tabs and some screens, so the arrows are
   worked out from the track rather than hardcoded. The panes are display:none
   until their tab is picked, which means a hidden track measures zero wide and
   would report no overflow. A ResizeObserver covers that: the moment a pane is
   shown the track resizes from nothing to its real width and we recheck. */
(function () {
  function wire(rail) {
    if (rail.__cfRail) return;
    rail.__cfRail = true;

    var track = rail.querySelector('[data-cf-rail-track]');
    var prev = rail.querySelector('[data-cf-rail-prev]');
    var next = rail.querySelector('[data-cf-rail-next]');
    if (!track || !prev || !next) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 4 || track.clientWidth === 0) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = track.scrollLeft <= 4;
      next.hidden = track.scrollLeft >= max - 4;
    }

    function step(dir) {
      var card = track.querySelector('.cf-card');
      var w = card ? card.getBoundingClientRect().width + 18 : 228;
      var by = Math.max(w, Math.floor(track.clientWidth / w) * w);
      track.scrollBy({ left: dir * by, behavior: 'smooth' });
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });
    track.addEventListener('scroll', update, { passive: true });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(track);
    }
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    var rails = document.querySelectorAll('[data-cf-rail]');
    for (var i = 0; i < rails.length; i++) wire(rails[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();
